import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/warehouse',
  title: '仓库管理',
  component: dynamicWrapper(app, [import('./model')], () => import('./components'))
});

export default app => createRoute(app, routesConfig);
